import { render, staticRenderFns } from "./PrefixPicker.vue?vue&type=template&id=43b59b40&scoped=true"
import script from "./PrefixPicker.vue?vue&type=script&lang=js"
export * from "./PrefixPicker.vue?vue&type=script&lang=js"
import style0 from "./PrefixPicker.vue?vue&type=style&index=0&id=43b59b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b59b40",
  null
  
)

export default component.exports